<div class="leave-policies-container" style="position:relative">

  <!-- ══════════════ HR Navigation Header ══════════════ -->
  <div class="lp-nav-header">
    <button class="lp-nav-tab lp-nav-tab--active" [routerLink]="['/ers/leave-management/manage-leave-policies']">
      {{ 'leave_management.manage_leave_policies.leave_allocate_amp_policies' | transloco }}
    </button>
    <button class="lp-nav-tab" [routerLink]="['/ers/leave-management/manage-holidays']">
      {{ 'leave_management.manage_leave_policies.holidays' | transloco }}
    </button>
  </div>

  <lm-loading-overlay [show]="isSaving" message="Saving..."></lm-loading-overlay>

  <!-- ══════════════ Two-Column Grid Layout ══════════════ -->
  <div class="lp-grids-container">
    <!-- Allocated Leaves -->
    <div class="lp-section-card">
      <div class="lp-section-header">
        <div class="lp-title-row">
          <h3 class="lp-section-title">{{ 'leave_management.manage_leave_policies.allocated_leaves' | transloco }}</h3>
          <div class="lp-year-control">
            <select class="lp-year-select" [(ngModel)]="selectedYear" (change)="onYearChange()">
              @for (y of availableYears; track y) {
              <option [value]="y">{{ y }}</option>
              }
            </select>
            <span class="lp-total-badge">Total {{ totalLeavesYearly }} Days / Year</span>
          </div>
        </div>
        <button class="lp-create-btn" (click)="onCreateNewLeave()">
          <span class="material-icons">{{ 'leave_management.manage_leave_policies.add' | transloco }}</span>
          {{ 'leave_management.manage_leave_policies.create_new_leave' | transloco }}
        </button>
      </div>
      <div class="lp-grid-wrapper">
        <ers-grid
          [rowData]="allocatedLeaves"
          [columnDefs]="leavesColDefs"
          [gridOptions]="leavesGridOptions"
          (cellClicked)="onLeavesGridCellClick($event)">
        </ers-grid>
      </div>
    </div>

    <!-- Policy Documents -->
    <div class="lp-section-card">
      <div class="lp-doc-header">
        <h3 class="lp-section-title">{{ 'leave_management.manage_leave_policies.leave_policy_documents' | transloco }}</h3>
        <button class="lp-upload-btn" (click)="onUploadClick()">
          <span class="material-icons">{{ 'leave_management.manage_leave_policies.upload' | transloco }}</span>
          {{ 'leave_management.manage_leave_policies.upload_document' | transloco }}
        </button>
      </div>

      <!-- Documents grid -->
      @if (docsLoading || policyDocuments.length > 0) {
      <div class="lp-grid-wrapper">
        <ers-grid
          [rowData]="policyDocuments"
          [columnDefs]="docColDefs"
          [gridOptions]="docGridOptions"
          (cellClicked)="onDocGridCellClick($event)">
        </ers-grid>
      </div>
      }

      <!-- Empty state -->
      @if (!docsLoading && policyDocuments.length === 0) {
      <div class="lp-empty-state">
        <svg width="174" height="168" viewBox="0 0 174 168" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_mlp)">
            <path d="M110.464 37.7826H63.5788C62.5104 37.7838 61.4861 38.2042 60.7306 38.9515C59.9751 39.6988 59.5501 40.712 59.5488 41.7688V144.84L59.0114 145.002L47.5097 148.486C46.9646 148.65 46.3758 148.594 45.8726 148.33C45.3694 148.065 44.9929 147.614 44.8258 147.075L10.6133 36.5362C10.4468 35.997 10.5036 35.4145 10.7711 34.9167C11.0386 34.4189 11.495 34.0465 12.04 33.8814L29.7641 28.5132L81.1471 12.9562L98.8712 7.58807C99.1409 7.50596 99.4244 7.47727 99.7053 7.50363C99.9863 7.53 100.259 7.61091 100.509 7.74174C100.758 7.87256 100.979 8.05073 101.158 8.26604C101.338 8.48136 101.473 8.72959 101.555 8.99655L110.3 37.2511L110.464 37.7826Z" fill="#F2F2F2"/>
            <path d="M161.91 154.713H71.1001C70.4946 154.712 69.9142 154.474 69.486 154.05C69.0579 153.627 68.8171 153.053 68.8164 152.454V44.8253C68.8171 44.2264 69.0579 43.6522 69.486 43.2288C69.9142 42.8053 70.4946 42.5671 71.1001 42.5664H161.91C162.516 42.5671 163.096 42.8053 163.524 43.2288C163.952 43.6522 164.193 44.2264 164.194 44.8253V152.454C164.193 153.053 163.952 153.627 163.524 154.05C163.096 154.474 162.516 154.712 161.91 154.713Z" fill="#E6E6E6"/>
          </g>
          <defs><clipPath id="clip0_mlp"><rect width="174" height="168" fill="white"/></clipPath></defs>
        </svg>
        <p class="lp-empty-text">{{ 'leave_management.manage_leave_policies.no_policy_documents_available' | transloco }}</p>
      </div>
      }
    </div>
  </div>

</div>
